import React, { useState } from 'react';
import { VaultKeTheme } from '../../utils/theme';

const Contact: React.FC = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: '',
  });

  const styles: { [key: string]: React.CSSProperties } = {
    page: {
      minHeight: '100vh',
      backgroundColor: VaultKeTheme.colors.background,
      color: VaultKeTheme.colors.text,
    },
    main: {
      paddingTop: '80px',
      paddingBottom: VaultKeTheme.spacing.xxl,
    },
    container: {
      maxWidth: '1200px',
      margin: '0 auto',
      padding: `0 clamp(${VaultKeTheme.spacing.md}, 5vw, ${VaultKeTheme.spacing.xl})`,
    },
    header: {
      textAlign: 'center',
      marginBottom: VaultKeTheme.spacing.xxl,
    },
    title: {
      ...VaultKeTheme.typography.h1,
      color: VaultKeTheme.colors.text,
      marginBottom: VaultKeTheme.spacing.lg,
    },
    subtitle: {
      ...VaultKeTheme.typography.body1,
      color: VaultKeTheme.colors.textSecondary,
      maxWidth: '600px',
      margin: '0 auto',
    },
    content: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
      gap: VaultKeTheme.spacing.xxl,
    },
    contactInfo: {
      ...VaultKeTheme.components.card,
    },
    sectionTitle: {
      ...VaultKeTheme.typography.h3,
      color: VaultKeTheme.colors.text,
      marginBottom: VaultKeTheme.spacing.lg,
    },
    contactItem: {
      display: 'flex',
      alignItems: 'center',
      gap: VaultKeTheme.spacing.md,
      marginBottom: VaultKeTheme.spacing.lg,
      flexWrap: 'wrap',
    },
    contactIcon: {
      fontSize: '1.5rem',
      color: VaultKeTheme.colors.primary,
      flexShrink: 0,
    },
    contactText: {
      ...VaultKeTheme.typography.body1,
      color: VaultKeTheme.colors.textSecondary,
      flex: 1,
      minWidth: 0,
    },
    form: {
      ...VaultKeTheme.components.card,
    },
    formGroup: {
      marginBottom: VaultKeTheme.spacing.lg,
    },
    label: {
      ...VaultKeTheme.typography.body2,
      color: VaultKeTheme.colors.text,
      display: 'block',
      marginBottom: VaultKeTheme.spacing.sm,
      fontWeight: '600',
    },
    input: {
      ...VaultKeTheme.components.input,
      width: '100%',
    },
    textarea: {
      ...VaultKeTheme.components.input,
      width: '100%',
      minHeight: '120px',
      resize: 'vertical',
    },
    button: {
      ...VaultKeTheme.components.button.primary,
      width: '100%',
      padding: '16px',
    },
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Handle form submission here
    console.log('Form submitted:', formData);
  };

  return (
    <div style={styles.page}>
      <main style={styles.main}>
        <div style={styles.container}>
          <div style={styles.header}>
            <h1 style={styles.title}>Contact Us</h1>
            <p style={styles.subtitle}>
              Have questions about VaultKe? We'd love to hear from you.
              Send us a message and we'll respond as soon as possible.
            </p>
          </div>

          <div style={styles.content}>
            <div style={styles.contactInfo}>
              <h2 style={styles.sectionTitle}>Get in Touch</h2>

              <div style={styles.contactItem}>
                <div style={styles.contactIcon}>📧</div>
                <div style={styles.contactText}>
                  <strong>Email:</strong> support@vaultke.com
                </div>
              </div>

              <div style={styles.contactItem}>
                <div style={styles.contactIcon}>📱</div>
                <div style={styles.contactText}>
                  <strong>Phone:</strong> +254 700 000 000
                </div>
              </div>

              <div style={styles.contactItem}>
                <div style={styles.contactIcon}>📍</div>
                <div style={styles.contactText}>
                  <strong>Address:</strong> Kisumu, Kenya
                </div>
              </div>

              <div style={styles.contactItem}>
                <div style={styles.contactIcon}>🕒</div>
                <div style={styles.contactText}>
                  <strong>Support Hours:</strong> Mon-Fri 9AM-6PM EAT
                </div>
              </div>
            </div>

            <form style={styles.form} onSubmit={handleSubmit}>
              <h2 style={styles.sectionTitle}>Send us a Message</h2>

              <div style={styles.formGroup}>
                <label style={styles.label} htmlFor="name">Full Name</label>
                <input
                  style={styles.input}
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleInputChange}
                  required
                />
              </div>

              <div style={styles.formGroup}>
                <label style={styles.label} htmlFor="email">Email Address</label>
                <input
                  style={styles.input}
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleInputChange}
                  required
                />
              </div>

              <div style={styles.formGroup}>
                <label style={styles.label} htmlFor="subject">Subject</label>
                <input
                  style={styles.input}
                  type="text"
                  id="subject"
                  name="subject"
                  value={formData.subject}
                  onChange={handleInputChange}
                  required
                />
              </div>

              <div style={styles.formGroup}>
                <label style={styles.label} htmlFor="message">Message</label>
                <textarea
                  style={styles.textarea}
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleInputChange}
                  required
                />
              </div>

              <button style={styles.button} type="submit">
                Send Message
              </button>
            </form>
          </div>
        </div>
      </main>
    </div>
  );
};

export default Contact;